var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t加班申请-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": "加班人",
      "prop": "overtime_staff"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.overtime_staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "overtime_staff_name", $$v)
      },
      expression: "ruleForm.overtime_staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "start_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.start_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "start_date", $$v)
      },
      expression: "ruleForm.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "end_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.end_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "end_date", $$v)
      },
      expression: "ruleForm.end_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加班时长",
      "prop": "overtime_duration"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.ruleForm.overtime_duration),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "overtime_duration", $$v)
      },
      expression: "ruleForm.overtime_duration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加班原因",
      "prop": "overtime_reason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入加班原因"
    },
    model: {
      value: (_vm.ruleForm.overtime_reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "overtime_reason", $$v)
      },
      expression: "ruleForm.overtime_reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.AddAuditor()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.UpdateAuditor()
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择加班人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "checkbox",
      "accordion": true,
      "staff_ids_prop": _vm.object.staff_ids
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择审核人",
      "visible": _vm.dialogAuditorVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAuditorVisible = $event
      }
    }
  }, [_c('SelectAuditor', {
    ref: "SelectAuditor",
    attrs: {
      "type": 1,
      "examineDetailsList": _vm.ruleForm.examineDetailsList,
      "id": _vm.ruleForm.id
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdb705a4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Jbsq/Jbsq_add.vue
// module id = null
// module chunks = 